import { useCallback, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

import { TopMenu } from '../../Components/'
import { PageContainer } from '../../Components/Common/PageContainer'
import { Sidebar } from '../../Components/Common/SlidingMenu'
import { useAuth } from '../../Provider/AuthProvider'
import { FC } from '../../Services'
import { useMenuItems } from '../../Services/MenuConfig'

const MOBILE_BREAKPOINT = '(max-width: 900px)'

function ProtectedRoute({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { onLogout, user: userObj = {} } = useAuth()
  const { user = {} } = userObj || {}
  const menuItems = useMenuItems(user)
  const [sideCollapsed, setSideCollapsed] = useState(false)
  const [sideMobileOpen, setSideMobileOpen] = useState(false)

  const toggleSidebar = useCallback(() => {
    if (window.matchMedia(MOBILE_BREAKPOINT).matches) {
      setSideMobileOpen((open) => !open)
      return
    }
    setSideCollapsed((collapsed) => !collapsed)
  }, [])

  const closeMobileSidebar = useCallback(() => {
    setSideMobileOpen(false)
  }, [])

  if (!FC.authenticated) return <Navigate to="/login" replace state={{ from: location }} />

  const menuAction = (page) => (page === 'logout' ? onLogout() : navigate(page))

  const shellClassName = [
    'nora-shell-v2',
    sideCollapsed ? 'is-side-collapsed' : '',
    sideMobileOpen ? 'is-side-mobile-open' : ''
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={shellClassName}>
      <Sidebar
        menuAction={menuAction}
        menuItems={menuItems}
        collapsed={sideCollapsed}
        mobileOpen={sideMobileOpen}
        onCloseMobile={closeMobileSidebar}
      />
      <div className="nora-shell-v2__col">
        <TopMenu onToggleSidebar={toggleSidebar} />
        <PageContainer>
          <Outlet />
        </PageContainer>
      </div>
    </div>
  )
}

export default ProtectedRoute
